import { useEffect } from 'react';

const siteUrl = import.meta.env.VITE_SITE_URL || 'https://example.com';

const schemaData = {
  '@context': 'https://schema.org',
  '@graph': [
    {
      '@type': 'LocalBusiness',
      '@id': `${siteUrl}/#localbusiness`,
      name: 'NJ Commercial Asphalt Paving',
      description:
        'NJ Commercial Asphalt Paving is a trusted commercial asphalt paving contractor serving all of New Jersey. We specialize in commercial paving, parking lot paving, asphalt repair, sealcoating, crack filling, and pavement maintenance for large and small projects.',
      url: siteUrl,
      telephone: '+1-856-677-6191',
      priceRange: '$$',
      image: `${siteUrl}/og-image.jpg`,
      logo: `${siteUrl}/logo.png`,
      address: {
        '@type': 'PostalAddress',
        addressRegion: 'NJ',
        addressCountry: 'US',
        addressLocality: 'New Jersey',
      },
      geo: {
        '@type': 'GeoCoordinates',
        latitude: 40.0583,
        longitude: -74.4057,
      },
      areaServed: {
        '@type': 'State',
        name: 'New Jersey',
      },
      hasOfferCatalog: {
        '@type': 'OfferCatalog',
        name: 'Asphalt Paving Services',
        itemListElement: [
          { '@type': 'Offer', itemOffered: { '@type': 'Service', name: 'Commercial Paving' } },
          { '@type': 'Offer', itemOffered: { '@type': 'Service', name: 'Asphalt Paving' } },
          { '@type': 'Offer', itemOffered: { '@type': 'Service', name: 'Parking Lot Paving' } },
          { '@type': 'Offer', itemOffered: { '@type': 'Service', name: 'Parking Lot Repair' } },
          { '@type': 'Offer', itemOffered: { '@type': 'Service', name: 'Asphalt Repair' } },
          { '@type': 'Offer', itemOffered: { '@type': 'Service', name: 'Crack Filling' } },
          { '@type': 'Offer', itemOffered: { '@type': 'Service', name: 'Asphalt Sealcoating' } },
          { '@type': 'Offer', itemOffered: { '@type': 'Service', name: 'Asphalt Milling' } },
          { '@type': 'Offer', itemOffered: { '@type': 'Service', name: 'Parking Lot Striping' } },
          { '@type': 'Offer', itemOffered: { '@type': 'Service', name: 'Pavement Maintenance' } },
        ],
      },
      contactPoint: {
        '@type': 'ContactPoint',
        telephone: '+1-856-677-6191',
        contactType: 'customer service',
        areaServed: 'US-NJ',
        availableLanguage: 'English',
      },
      sameAs: [],
    },
    {
      '@type': 'WebSite',
      '@id': `${siteUrl}/#website`,
      url: siteUrl,
      name: 'NJ Commercial Asphalt Paving',
      description: 'Commercial asphalt paving contractor serving all of New Jersey.',
      publisher: {
        '@id': `${siteUrl}/#localbusiness`,
      },
    },
    {
      '@type': 'WebPage',
      '@id': `${siteUrl}/#webpage`,
      url: siteUrl,
      name: 'NJ Commercial Asphalt Paving | New Jersey Asphalt Contractor | (856) 677-6191',
      description:
        'NJ Commercial Asphalt Paving — trusted commercial asphalt paving contractor serving all of New Jersey. Immediate availability. Call (856) 677-6191.',
      isPartOf: { '@id': `${siteUrl}/#website` },
      about: { '@id': `${siteUrl}/#localbusiness` },
      inLanguage: 'en-US',
    },
  ],
};

export default function HomeSchemaLD() {
  useEffect(() => {
    const existing = document.getElementById('home-schema-ld');
    if (existing) return;
    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.id = 'home-schema-ld';
    script.textContent = JSON.stringify(schemaData);
    document.head.appendChild(script);
    return () => {
      const el = document.getElementById('home-schema-ld');
      if (el) el.remove();
    };
  }, []);

  return null;
}
